import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TopLevelExpander from './TopLevelExpander';
import { getItemsForEstimate } from '../../selectors/getItemsForEstimate';
import expandAll from '../../actions/uiState/expandAll';
import collapseAll from '../../actions/uiState/collapseAll';

const mapStateToProps = ({ estimateBuilder }) => {
  const thisEstItems = getItemsForEstimate(
    estimateBuilder.entities,
    estimateBuilder.uiState.selectedEstimate,
  );
  const showExpander = thisEstItems.filter(item => !!item.itemProduct).length > 0;

  const { expandedItems } = estimateBuilder.uiState;
  const allExpandedReducer = (acc, thisItem) =>
    acc && expandedItems.indexOf(thisItem.itemId) !== -1;
  const allExpanded = thisEstItems.reduce(allExpandedReducer, true);

  return {
    showExpander,
    allExpanded,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({ collapseAll, expandAll }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TopLevelExpander);
